import appConfig from "../../../config/app-config";


export function getCookieValue(name) {
  const cookies = document.cookie.split(';');
  const prefix = `${name}=`;

  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.startsWith(prefix)) {
      return cookie.slice(prefix.length);
    }
  }

  return null; // clearer than empty string
}

export function removeCookie(cookieName) {
  if (cookieName) {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}

export function setLaunchdeckAffiliationCookie(attributionCode) {
  const { signupAttributionCookieName: cookieName } = appConfig;
  const existingCode = getCookieValue(cookieName);
  const cookieValidityInDays = 7;
 

  if (attributionCode && attributionCode !== existingCode) {
    const maxAge = 60 * 60 * 24 * cookieValidityInDays;
    document.cookie = `${cookieName}=${attributionCode}; path=/; max-age=${maxAge}`;
  }
}